import { Route, Routes } from "react-router-dom";
import { RequireAuth } from "./auth/RequireAuth";
import { AdminShell } from "./layout/AdminShell";
import { AuditLogPage } from "./pages/AuditLogPage";
import { FastFoodStepFormPage } from "./pages/FastFoodStepFormPage";
import { InvitesPage } from "./pages/InvitesPage";
import { LeadDetailsPage } from "./pages/LeadDetailsPage";
import { LeadPartnersPage } from "./pages/LeadPartnersPage";
import { LeadsPage } from "./pages/LeadsPage";
import { NoAccessPage, NotFoundPage } from "./pages/NoAccessPage";
import { OgiRetrievePage } from "./pages/OgiRetrievePage";
import { OverviewPage } from "./pages/OverviewPage";
import { PricingCalculatorPage } from "./pages/PricingCalculatorPage";
import { QuoteDetailsPage } from "./pages/QuoteDetailsPage";
import { QuoteFinderPage } from "./pages/QuoteFinderPage";
import { QuotesPage } from "./pages/QuotesPage";
import { SignInPage } from "./pages/SignInPage";
import { UsersPage } from "./pages/UsersPage";

/**
 * Every route below the shell is wrapped in RequireAuth, which checks the
 * session and the specific permission. These guards decide what renders;
 * dave-service independently authorises each API call behind them.
 */
export default function App() {
  return (
    <Routes>
      <Route path="/sign-in" element={<SignInPage />} />

      <Route
        element={
          <RequireAuth>
            <AdminShell />
          </RequireAuth>
        }
      >
        <Route index element={<OverviewPage />} />
        <Route path="no-access" element={<NoAccessPage />} />

        <Route
          path="quotes"
          element={
            <RequireAuth permission="quotes.view">
              <QuotesPage />
            </RequireAuth>
          }
        />
        <Route
          path="quotes/:id"
          element={
            <RequireAuth permission="quotes.view">
              <QuoteDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path="pricing-calculator"
          element={
            <RequireAuth permission="quotes.view">
              <PricingCalculatorPage />
            </RequireAuth>
          }
        />
        <Route
          path="quote-finder"
          element={
            <RequireAuth permission="quotes.search">
              <QuoteFinderPage />
            </RequireAuth>
          }
        />
        <Route
          path="leads"
          element={
            <RequireAuth permission="leads.view">
              <LeadsPage />
            </RequireAuth>
          }
        />
        <Route
          path="leads/:id"
          element={
            <RequireAuth permission="leads.view">
              <LeadDetailsPage />
            </RequireAuth>
          }
        />
        <Route
          path="ogi-retrieve"
          element={
            <RequireAuth permission="ogi.retrieve">
              <OgiRetrievePage />
            </RequireAuth>
          }
        />
        <Route
          path="step-forms/fast-food"
          element={
            <RequireAuth permission="stepforms.use">
              <FastFoodStepFormPage />
            </RequireAuth>
          }
        />

        <Route
          path="lead-partners"
          element={
            <RequireAuth permission="partners.manage">
              <LeadPartnersPage />
            </RequireAuth>
          }
        />
        <Route
          path="users"
          element={
            <RequireAuth permission="users.manage">
              <UsersPage />
            </RequireAuth>
          }
        />
        <Route
          path="invites"
          element={
            <RequireAuth permission="invites.manage">
              <InvitesPage />
            </RequireAuth>
          }
        />
        <Route
          path="audit"
          element={
            <RequireAuth permission="audit.view">
              <AuditLogPage />
            </RequireAuth>
          }
        />

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
